import type React from "react";

interface LoadingScreenProps {
	message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
	message = "Loading...",
}) => {
	return (
		<div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-75 z-50">
			<div className="text-center">
				<div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4" />
				<p className="text-xl font-semibold text-gray-700">{message}</p>
			</div>
		</div>
	);
};

export default LoadingScreen;
